import { flattenDeep, groupBy, uniq } from 'lodash';

import { INSTRUCTOR_CATEGORIES } from '@classCreation/data/instructorCategories';

export default function generatePreviousSbatGroupsInstructorIds(sbatGroups) {
  const previousInstructors = groupBy(
    flattenDeep(
      Object.values(sbatGroups).map(
        (sbatGroup) => sbatGroup.sbat_group_instructors
      )
    ),
    'category'
  );
  const previousPrimaryInstructorIds = uniq(
    previousInstructors[INSTRUCTOR_CATEGORIES.primary]?.map(
      (instructor) => instructor.instructor_id
    )
  );
  const previousSecondaryInstructorIds = uniq(
    previousInstructors?.[INSTRUCTOR_CATEGORIES.secondary]?.map(
      (instructor) => instructor?.instructor_id
    )
  );
  const previousOtherInstructorIds = uniq(
    previousInstructors?.[INSTRUCTOR_CATEGORIES.other]?.map(
      (instructor) => instructor?.instructor_id
    )
  );

  return {
    previousPrimaryInstructorIds,
    previousSecondaryInstructorIds,
    previousOtherInstructorIds,
  };
}
